<template>
    <div class="vx-card px-6 py-2" id="call_history">
        <div class="vx-row">
            <div class="vx-col xl:w-1/4 md:w-1/3 sm:w-1/2 sm:mt-0 mt-2 w-full">
                <label class="vs-input--label">Loại</label>
                <v-select v-model="selectedTypeCallValue" :options="typeCallOptions"
                          :clearable="false" name="employee" :reduce="item => item.value">
                </v-select>
            </div>
         
            <div class="vx-col xl:w-1/4 md:w-1/3 sm:w-1/2 w-full md:mt-0 mt-2">
                <label class="vs-input--label">Ngày kết thúc</label>
                <datepicker :highlighted="highlightedFn" :language="vi" :format="'dd/MM/yyyy'"
                            v-validate="'required'" :disabled-dates="disabledDates"
                            v-model="endDate" name="Ngày kết thúc" @update="dateRangePicker">
                </datepicker>
            </div>
            <div class="vx-col w-auto">
                <vs-button class="md:mt-6 sm:mt-8 mt-4" @click="filter">Tìm kiếm</vs-button>
            </div>
        </div>

        <vs-table class="table-custom mt-6" :data="callHistoryData" noDataText="Không có dữ liệu" stripe>
            <template slot="thead">
                <vs-th>
                    <div style="width: 120px;">
                        <label>Thời gian bắt đầu</label>
                        <datepicker :highlighted="highlightedFn" :language="vi" :format="'dd/MM/yyyy'"
                            v-validate="'required'" :disabled-dates="disabledDates"
                            v-model="startDate" name="Ngày bắt đầu" @update="dateRangePicker" style="width: 120px;">
                </datepicker>
                    </div>
                </vs-th>
                <vs-th>
                    <div>
                        <label>Nhân viên</label>
                         <vs-input v-model="employeeName" style="width: 120px;" @keyup.enter="filter"/>
                    </div>
                </vs-th>
                <vs-th>
                    <div class="w-full" >
                        <label>Thời lượng</label>
                    </div>
                </vs-th>
                <vs-th>
                    <div class="w-full" >
                        <label>Đối tượng tắt máy</label>
                         <vs-input style="width: 120px;"/>
                    </div>
                </vs-th>
                <vs-th>
                    <div class="w-full" >
                        <label>Ghi chú</label>
                         <vs-input style="width: 120px;"/>
                    </div>
                </vs-th>
                <vs-th>
                    <div class="w-full" >
                        <label>File Ghi âm</label>
                    </div>
                </vs-th>
                <vs-th>
                    <div class="w-full" >
                        <label>Tổng thời gian</label>
                         <vs-input style="width: 120px;"/>
                    </div>
                </vs-th>
                <vs-th style="width: 100px;">
                    <div class="w-full" >
                        <label>Hành động</label>
                    </div>
                </vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                        {{ tr.createdDate }}
                    </vs-td>
                    <vs-td>
                        {{ tr.callerMem }}
                    </vs-td>
                    <vs-td>
                        {{ tr.time_call }}
                    </vs-td>
                    <vs-td>
                    </vs-td>
                    <vs-td>
                    </vs-td>
                    <vs-td>
                        <CellRendererRecord2 :rowData="tr"></CellRendererRecord2>
                    </vs-td>
                    <vs-td>
                    </vs-td>
                    <vs-td>
                        <vx-tooltip class="position-icon" :text="$t('button.details')" position="top">
                            <feather-icon icon="EyeIcon" class="text-primary"
                                          svgClasses="h-5 w-5 hover:text-success icon-btn"
                                          @click="openCallHistoryDetails(tr)"/>
                        </vx-tooltip>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
        <div class="vx-row mt-4" v-if="callHistoryData.length > 0">
            <div class="vx-col md:w-1/2">
                <div
                    class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4 vx-row">
                    <span class="vx-col mt-2">Số phần tử / trang:</span>
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                        <div
                            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium vx-col">
                                <span class="mr-2">
                                    {{
                                        callHistoryData.length - currentPage * pageSize > 0 ? currentPage *
                                            pageSize
                                            : callHistoryData.length
                                    }} /
                                    {{ totalElements }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                        </div>
                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="changePageSize(10)">
                                <span>10</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="changePageSize(20)">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="changePageSize(30)">
                                <span>30</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="changePageSize(50)">
                                <span>50</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
                <vs-pagination :total="totalPages" v-model="currentPage" @change="loadPage"/>
            </div>
        </div>
        <vs-popup class="holamundo" id="popup-history-call" :active.sync="showCallHistoryDetails">
            <div class="vx-row">
                <div class="vx-col w-full flex justify-between">
                    <h4>Cuộc gọi</h4>
                    <feather-icon icon="XIcon" class="hover:text-danger" svgClasses="h-5 w-5"
                                  @click="closeCallHistoryDetails"/>
                </div>
            </div>

            <vs-divider/>

            <h5>Chi tiết</h5>
            <div class="vx-row mt-4">
                <div class="vx-col w-full">
                    <div class="vx-row">
                        <div class="vx-col w-1/3 flex items-center">
                            <span class="text-md font-semibold">Loại</span>
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-chip class="ag-grid-cell-chip"
                                     :color="callHistoryDetails ? chipColorType(callHistoryDetails.type_call) : null">
                                <span class="text-md font-semibold">{{
                                        callHistoryDetails ? checkStatusType(callHistoryDetails.type_call) : null
                                    }}</span>
                            </vs-chip>
                        </div>
                    </div>
                    <div class="vx-row mt-4">
                        <div class="vx-col w-1/3">
                            <span class="text-md font-semibold">Thời gian</span>
                        </div>
                        <div class="vx-col w-2/3">
                            <span
                                class="text-md">{{ callHistoryDetails ? callHistoryDetails.createdDate : null }}</span>
                        </div>
                    </div>
                    <div class="vx-row mt-4">
                        <div class="vx-col w-1/3">
                            <span class="text-md font-semibold">Thời lượng</span>
                        </div>
                        <div class="vx-col w-2/3">
                                            <span class="text-md">{{
                                                    callHistoryDetails ? callHistoryDetails.time_call : null
                                                }}</span>
                        </div>
                    </div>
                    <div class="vx-row mt-4">
                        <div class="vx-col w-1/3">
                            <span class="text-md font-semibold">Hotline</span>
                        </div>
                        <div class="vx-col w-2/3">
                            <span
                                class="text-md font-semibold">{{
                                    callHistoryDetails ? callHistoryDetails.hotline_number : null
                                }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <vs-divider/>

            <h5>Người gọi</h5>
            <div class="vx-row mt-4">
                <div class="vx-col w-1/2">
                    <span>{{ callHistoryDetails ? callHistoryDetails.callerMem : null }}</span>
                </div>
                <div class="vx-col w-1/2"
                     v-if="callHistoryDetails && callHistoryDetails.record_file.length > 0">
                    <div v-for="(record, index) in callHistoryDetails.record_file" :key="index"
                         class="text-primary float-right text-md font-semibold cursor-pointer flex items-center"
                         @click="startRecord(record)">
                        <span>{{ 'Tệp ghi âm ' + (index + 1) }}</span>
                        <feather-icon icon="PlayCircleIcon" class="action-success icon-btn"
                                      svgClasses="h-5 w-5"/>
                    </div>
                </div>
            </div>

            <vs-divider/>

            <h5>Người nhận</h5>
            <div class="vx-row mt-4">
                <div class="vx-col w-1/2 flex items-center">
                    <span>{{
                            (callHistoryDetails && callHistoryDetails.callee.length > 0) ? (callHistoryDetails.calleeMem + ' - ' + callHistoryDetails.callee[0].phone) : 'Không xác định'
                        }}</span>
                </div>
                <div class="vx-col w-1/2">
                    <vs-chip class="ag-grid-cell-chip float-right"
                             :color="callHistoryDetails ? chipColorStatus(callHistoryDetails.disposition) : null">
                        <span class="text-md font-semibold">{{
                                callHistoryDetails ? checkStatusStatus(callHistoryDetails.disposition) : null
                            }}</span>
                    </vs-chip>
                </div>
            </div>

            <vs-divider/>

            <h5>Đánh giá</h5>
            <div class="vx-row mt-4">
                <div class="vx-col w-full">
                    <star-rating v-model="rating" :star-size="25" :show-rating="false"
                                 :read-only="isRating" :border-width="4"
                                 border-color="#F3D23E"
                                 active-color="#F3D23E" :rounded-corners="true"
                                 :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]"
                                 class="mt-2"></star-rating>
                </div>
                <div class="vx-col w-full">
                    <vs-textarea class="w-full" v-model="review"
                                 aria-placeholder="Nhập đánh giá ..."
                                 :disabled="isRating"/>
                </div>
            </div>

            <div class="mt-4">
                <div class="flex float-right">
                    <vs-button color="primary" @click="saveReviewCall" class="mr-4"
                               v-if="!isRating">
                        Lưu
                    </vs-button>
                    <vs-button color="danger" type="border" @click="closeCallHistoryDetails">Đóng
                    </vs-button>
                </div>
            </div>

            <!--Popup audio record-->
            <vs-popup class="holamundo" id="popup-history-call-record"
                      :active.sync="showAudioRecord">
                <div class="vx-row">
                    <div class="vx-col w-full flex justify-between">
                        <h4>Ghi âm</h4>
                        <feather-icon icon="XIcon" class="hover:text-danger" svgClasses="h-5 w-5"
                                      @click="closeAudioRecord"/>
                    </div>
                </div>
                <vs-divider/>
                <div class="vx-row" v-if="showAudioRecord">
                    <div class="vx-col w-full">
                        <audio autoplay name="media" controls :src="dataRecord" type="audio/wav"
                               class="w-full">
                        </audio>
                    </div>
                </div>
            </vs-popup>
        </vs-popup>
    </div>
</template>

<script>
import moment from "moment";
import authConfig from "../../../../../../../auth_config.json";
import Datepicker from 'vuejs-datepicker';
import {en, vi} from "vuejs-datepicker/dist/locale";
import vSelect from 'vue-select';
import StarRating from 'vue-star-rating';
import CellRendererRecord2 from "./cell-renderer/CellRendererRecord.vue";

export default {
    name: "CallHistory",
    components: {
        Datepicker,
        vSelect,
        StarRating,
        CellRendererRecord2
    },
    props: {
        phone: {
            default: null,
            type: String,
        },
        callData: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            en: en,
            vi: vi,
            //Call history
            pageNumber: 0,
            pageSize: 10,
            currentPage: 1,
            totalPages: 1,
            totalElements: 0,
            callHistoryData: [],
            showCallHistoryDetails: false,
            callHistoryDetails: null,
            dataRecord: null,
            showAudioRecord: false,
            rating: null,
            isRating: false,
            review: null,
            // startDate: new Date(new Date(new Date().setMonth(new Date().getMonth()-1)).setHours(0,0,0,0)),
            // endDate: new Date(new Date().setHours(23,59,59,999)),
            startDate: null,
            endDate: null,
            highlightedFn: {
                customPredictor(date) {
                    if (moment(new Date()).format('YYYY-MM-DD') == moment(new Date(date)).format('YYYY-MM-DD')) {
                        return true;
                    }
                }
            },
            disabledDates: {
                customPredictor(date) {
                    if (moment(date).isAfter(moment(), 'days')) {
                        return true;
                    }
                }
            },
            selectedEmployeeValue: 'null',
            typeCallOptions: [
                {value: null, label: 'Tất cả'},
                {value: 'OUTCALL', label: 'Cuộc gọi đi'},
                {value: 'INCALL', label: 'Cuộc gọi đến'},
                {value: 'MISSCALL', label: 'Cuộc gọi nhỡ'},
            ],
            selectedTypeCallValue: null,
            employeeName:null,
        }
    },
    watch: {
        startDate(newDateRange) {
            this.getAllCallHistory();  
        }
    },

    computed: {
        chipColorType() {
            return value => {
                if (value == 'OUTCALL') {
                    return "success";
                } else if (value == 'INCALL') {
                    return 'warning'
                } else if (value == 'MISSCALL') {
                    return 'danger'
                }
            }
        },
        checkStatusType() {
            return value => {
                if (value == 'OUTCALL') {
                    return "Cuộc gọi đi";
                } else if (value == 'INCALL ') {
                    return 'Cuộc gọi đến'
                } else if (value == 'MISSCALL') {
                    return 'Cuộc gọi nhỡ'
                }
            }
        },
        chipColorStatus() {
            return value => {
                if (value == 'MORE') {
                    return "success";
                } else if (value == 'MISSCALL') {
                    return 'warning'
                } else if (value == 'ANSWER') {
                    return 'success'
                } else if (value == 'BUSY') {
                    return 'danger'
                } else if (value == 'NOANSWER') {
                    return 'warning'
                } else if (value == 'CANCEL') {
                    return 'danger'
                } else if (value == 'SOMEONEANSWERED') {
                    return 'warning'
                } else if (value == 'LOGOUT') {
                    return 'warning'
                } else if (value == 'INCALL') {
                    return 'warning'
                } else if (value == 'CONGESTION' || value == 'CHANUNAVAIL' || value == 'DONTCALL' || value == 'TORTURE' || value == 'INVALIDARGS' || value == 'ORMAL_CLEARING') {
                    return 'danger'
                }
            }
        },
        checkStatusStatus() {
            return value => {
                if (value == 'MORE') {
                    return "Nhiều trạng thái khác của cuộc gọi";
                } else if (value == 'MISSCALL') {
                    return 'Cuộc gọi nhỡ'
                } else if (value == 'ANSWER') {
                    return 'Nghe máy'
                } else if (value == 'BUSY') {
                    return 'Người nhận bận'
                } else if (value == 'NOANSWER') {
                    return 'Người nhận không trả lời'
                } else if (value == 'CANCEL') {
                    return 'Người gọi hủy cuộc gọi'
                } else if (value == 'SOMEONEANSWERED') {
                    return 'Đã có người khác nghe máy'
                } else if (value == 'LOGOUT') {
                    return 'Đang trong trạng thái Logout'
                } else if (value == 'INCALL') {
                    return 'Đang trong cuộc gọi khác'
                } else if (value == 'CONGESTION' || value == 'CHANUNAVAIL' || value == 'DONTCALL' || value == 'TORTURE' || value == 'INVALIDARGS' || value == 'ORMAL_CLEARING') {
                    return 'Lỗi cuộc gọi'
                }
            }
        },
    },

    async created() {
        await this.getAllCallHistory();
    },

    methods: {
        //Call history
        dateRangePicker: function () {
            this.startDate = new Date(this.startDate.setHours(0, 0, 0, 0));
            this.endDate = new Date(this.endDate.setHours(23, 59, 59, 999));
        },
        getAllCallHistory() {
            this.$vs.loading();
            this.callHistoryData = [];
            let body = {
                page: this.pageNumber,
                size: this.pageSize,
                startDate: this.startDate,
                endDate: this.endDate,
                typeCall: this.selectedTypeCallValue,
                phone: this.phone,
                employeeName:this.employeeName ? this.employeeName : null
                // loyaltyCustomerId:this.callData.loyaltyCustomerId
            }

            this.$crm.post('/ott/vbot/search-call-history', body).then(res => {
                if (res.data.content && res.data.content.length > 0) {
                    this.callHistoryData = res.data.content.map(el => {
                        el.stt = this.pageNumber * this.pageSize + res.data.content.indexOf(el) + 1;
                        el.callerMem = (el.caller && el.caller.length > 0) ? el.caller[0].employee.fullName : null;
                        el.calleeMem = (el.callee.length > 0 && el.callee[0].user) ? el.callee[0].user.fullName : 'Không xác định';
                        el.calleeMemPhone = el.callee.length > 0 ? el.callee[0].phone : null;
                        el.createdDate = moment(el.date_create).format('DD/MM/YYYY HH:mm:ss');
                        return el;
                    });
                }
                this.totalPages = res.data.totalPages;
                this.totalElements = res.data.totalElements;
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        changePageSize(number) {
            this.pageSize = number;
            this.pageNumber = 0;
            this.currentPage = 1;
            this.getAllCallHistory();
        },
        loadPage: function (currentPage) {
            if (this.pageNumber !== parseInt(currentPage) - 1) {
                this.pageNumber = parseInt(currentPage) ? parseInt(currentPage) - 1 : 0;
                this.getAllCallHistory();
            }
        },
        filter() {
            if (this.startDate > this.endDate) {
                return this.$vs.notify({
                    text: 'Ngày bắt đầu phải nhỏ hơn ngày kết thúc!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            this.currentPage = 1;
            this.pageNumber = 0;
            this.getAllCallHistory();
        },
        async openCallHistoryDetails(data) {
            if (this.dataRecord) await this.deleteRecordFile();
            this.callHistoryDetails = data;
            this.rating = data.rating;
            if (this.rating) this.isRating = true;
            this.review = data.review;
            this.showCallHistoryDetails = true;
        },
        async closeCallHistoryDetails() {
            if (this.dataRecord) await this.deleteRecordFile();
            this.showCallHistoryDetails = false;
            this.callHistoryDetails = null;
            this.rating = null;
            this.review = null;
            this.isRating = false;
        },
        async closeAudioRecord() {
            await this.deleteRecordFile();
            this.dataRecord = null;
            this.showAudioRecord = false;
        },
        startRecord(e) {
            let payload = {
                recordFileUrl: e
            }
            this.$vs.loading();
            this.$crm.post('/ott/vbot/get-record-file', payload).then(res => {
                this.$vs.loading.close();
                if (res) {
                    this.dataRecord = authConfig.audioDomain + res.data;
                } else {
                    return this.$vs.notify({
                        text: 'Không tồn tại file ghi âm!',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                }
                this.showAudioRecord = true;
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        saveReviewCall() {
            if (!this.rating) {
                return this.$vs.notify({
                    text: 'Vui lòng đánh giá chất lượng cuộc gọi!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }

            let payload = {
                id: this.callHistoryDetails.id,
                rating: this.rating,
                review: this.review
            }
            this.$vs.loading();
            this.$crm.post('/ott/vbot/call-history-rating', payload).then(() => {
                this.$vs.notify({
                    text: 'Đánh giá cuộc gọi thành công!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                });
                this.closeCallHistoryDetails();
                this.getAllCallHistory();
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        deleteRecordFile() {
            return new Promise((resolve, reject) => {
                let payload = {
                    recordFileUrl: this.dataRecord,
                }

                this.$vs.loading();
                this.$crm.post('/ott/vbot/delete-record-file', payload).then(() => {
                    resolve();
                    this.$vs.loading.close()
                }).catch((err) => {
                    reject(err);
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.ag-grid-cell-chip-call-history {
&.vs-chip-success {
     background: rgba(var(--vs-success), .2);
     color: rgba(var(--vs-success), 1) !important;
     font-weight: 500;
 }

&.vs-chip-danger {
     background: rgba(var(--vs-danger), .2);
     color: rgba(var(--vs-danger), 1) !important;
     font-weight: 500;
 }

&.vs-chip-warning {
     background: rgba(var(--vs-warning), .2);
     color: rgba(var(--vs-warning), 1) !important;
     font-weight: 500;
 }

&.vs-chip-pending {
     background: rgb(143, 143, 143, .2) !important;
     color: rgb(143, 143, 143) !important;
     font-weight: 500;
 }

&.vs-chip-complete {
     background: rgba(157, 101, 201, .2) !important;
     color: rgb(157, 101, 201) !important;
     font-weight: 500;
 }
}

#popup-history-call {
    z-index: 54000 !important;

    .vs-popup--header {
        display: none;
    }
}

#popup-history-call-record {
    z-index: 55000 !important;

    .vs-popup--header {
        display: none;
    }
}
.table-custom .vs-table--tbody{
    min-height: 300px;
}
</style>
